import { Component, Injector } from '@angular/core';
import {
  BaseResourceListComponent, Coluna, Credito, Filtro, FormatoExportacao, GlobalService, LoginContabil
} from 'eddydata-lib';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CreditoService } from '../service/credito.service';

@Component({
  selector: 'app-credito-list',
  templateUrl: './credito-list.component.html'
})
export class CreditoListComponent extends BaseResourceListComponent<Credito, LoginContabil> {

  /**
   * Declaração de variáveis
   */

  /**
   * Construtor com as injeções de dependencias
   */
  constructor(
    protected injector: Injector,
    public globalService: GlobalService,
    private creditoService: CreditoService) {
    super(creditoService, injector);
  }

  // ========================================================================
  //                        MÉTODOS ABSTRAÍDOS
  // ========================================================================

  protected relations(): string {
    return 'orgao,exercicio';
  }

  protected condicoesGrid(): {} {
    return {
      ['exercicio.id']: this.login.exercicio.id,
      ['orgao.id']: this.login.orgao.id
    };
  }

  protected ordenacaoGrid(): string[] {
    return ['data_credito$DESC'];
  }

  protected filtrosGrid(): Filtro {
    return {
      date: ['data_credito'],
      text: ['ocorrencia', 'decreto', 'lei'],
    };
  }

  protected afterInit(): void {
  }

  protected acaoRemover(model: Credito): Observable<Credito> {
    return null;
  }

  protected colunasRelatorio(): string[] | Coluna[] {
    return [
      { titulo: 'Decreto', coluna: 'decreto', bold: true },
      { titulo: 'Lei', coluna: 'lei', bold: true },
      { titulo: 'Crédito', coluna: 'data_credito' },
      { titulo: 'Ocorrência', coluna: 'ocorrencia' }
    ];
  }

  public exportarListagem(formato: FormatoExportacao) {
    const parametros = this.obterParametros();
    parametros['relations'] = 'orgao,exercicio';
    this.creditoService
      .filtrar(1, -1,
        parametros
      )
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        lista => {
          if (formato === 'pdf') {
            this.imprimir('LISTAGEM DE CRÉDITOS ADICIONAIS', this.login.usuario.nome,
              this.login.orgao.nome, this.login.brasao, 'portrait',
              'Listagem créditos', ['auto', 'auto', 'auto', '*'], lista.content);
          } else {
            this.exportar(formato, lista.content);
          }
        },
        error => alert('erro ao retornar lista')
      );
  }

  // ========================================================================
  //                            MÉTODOS DA CLASSE
  // ========================================================================

  public voltar() {
    switch (this.login.sistema) {
      case 'contabil':
        this.router.navigate(['/planejamento']);
        break;
      default:
        this.sair();
        break;
    }
  }
}
